import { Component, Input, OnChanges, input } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { DirectSubscriptionService } from '@app/modules/direct/services/direct-subscription.service';
import { Reservation, ReservationPaymentStatus, ReservationPaymentTerm } from '@app/shared/interfaces';
import {
  GuestPortalStatus,
  GuestVettingData,
  ReservationStatus,
  SupervisedStatus,
  VerificationStatus,
} from '@app/shared/interfaces/lib/guestvetting.interface';
import {
  Provider,
  VerificationData,
  VerificationRatingStatus,
} from '@app/shared/services/guest-portal/guest-portal.service';
import { GuestVettingService } from '@app/shared/services/guest-vetting/guest-vetting.service';
import { DialogExtendGracePeriodComponent } from '../dialog-extend-grace-period/dialog-extend-grace-period.component';

@Component({
  standalone: false,
  selector: 'sbnb-thread-page-level-messages',
  templateUrl: './thread-page-level-messages.component.html',
  styleUrls: ['./thread-page-level-messages.component.scss', './thread-page-level-messages.component.mobile.scss'],
})
export class ThreadPageLevelMessagesComponent implements OnChanges {
  GuestVerificationProvider = Provider;

  @Input() activeReservation: Reservation;
  @Input() thread: any;
  @Input() guestVettingData: GuestVettingData;
  guestVetting = input<VerificationData>();

  ReservationPaymentStatus = ReservationPaymentStatus;
  VerificationStatus = VerificationStatus;
  VerificationRatingStatus = VerificationRatingStatus;
  ReservationStatus = ReservationStatus;
  verificationInReview = false;
  paymentTermThatCanBeExtended: ReservationPaymentTerm;
  GuestPortalStatus = GuestPortalStatus;
  public isMobile: boolean;
  isDirectOnboarded$ = this.directSubscriptionService.isOnboarded$;
  constructor(
    private dialog: MatDialog,
    private guestVettingService: GuestVettingService,
    private directSubscriptionService: DirectSubscriptionService
  ) {}

  ngOnChanges(): void {
    this.verificationInReview =
      this.activeReservation?.autohost?.status === VerificationStatus.REVIEW &&
      this.activeReservation?.autohost?.supervised !== SupervisedStatus.APPROVE;

    if (this.activeReservation && this.activeReservation.payment_terms) {
      const paymentTermThatCanBeExtended = this.activeReservation.payment_terms.find((term) => term.can_extend);

      if (paymentTermThatCanBeExtended) {
        this.paymentTermThatCanBeExtended = paymentTermThatCanBeExtended;
      }
    }
  }

  formatTime(timeString: string): string {
    if (!timeString) {
      return '';
    }

    const [hourString, minute] = timeString.split(':');
    const hour = +hourString % 24;
    return (hour % 12 || 12) + ':' + minute + (hour < 12 ? 'AM' : 'PM');
  }

  addOrdinalSuffix(day: number): string {
    if (day > 3 && day < 21) return day + 'th';
    switch (day % 10) {
      case 1:
        return day + 'st';
      case 2:
        return day + 'nd';
      case 3:
        return day + 'rd';
      default:
        return day + 'th';
    }
  }

  public openVettingDetails({ reservation, autohostBasicDetails }) {
    this.guestVettingService.openVettingDetails({ reservation, autohostBasicDetails });
  }

  showExtendGracePeriodDialog() {
    if (this.paymentTermThatCanBeExtended) {
      const dialogRef = this.dialog.open(DialogExtendGracePeriodComponent, {
        width: '720px',
        maxHeight: '90vh',
        data: {
          paymentUuid: this.paymentTermThatCanBeExtended.payment_uuid,
          reservationUuid: this.activeReservation.uuid,
          code: this.activeReservation.code,
        },
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.paymentTermThatCanBeExtended.grace_period_end = result;
        }
      });
    }
  }
}
